import { render, staticRenderFns } from "./quickReplyConfiguration.vue?vue&type=template&id=60c752fa&scoped=true&"
import script from "./quickReplyConfiguration.vue?vue&type=script&lang=js&"
export * from "./quickReplyConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./quickReplyConfiguration.vue?vue&type=style&index=0&id=60c752fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c752fa",
  null
  
)

component.options.__file = "quickReplyConfiguration.vue"
export default component.exports